import {
  SvgCustoms,
  SvgDeliveryGuarantee,
  SvgNotification,
  SvgPrintInStore,
  SvgProtection,
  SvgProtectionAdd,
  SvgProtectionExtra,
  SvgSignature,
  SvgVan
} from '@parcel2go/core-ui';
import { SVGProps } from 'react';
import { DutyUpsell, Label, Protection, Upsell } from '~/lib/types/extra-types';

export const UpsellDefaultIcon = (key: string | undefined, selected: boolean) => {
  switch (key) {
    case Upsell.SMS:
      return SvgNotification;

    case Upsell.GUARANTEE:
      return SvgDeliveryGuarantee;

    case Upsell.SIGNATURE:
      return SvgSignature;

    case Label.DRIVER:
      return SvgVan;

    case DutyUpsell.DDP:
      return SvgCustoms;

    case Protection.BASE:
      return selected ? SvgProtection : SvgProtectionAdd;

    case Protection.FULL:
      return selected ? SvgProtectionExtra : SvgProtectionAdd;

    case Label.STORE:
      return SvgPrintInStore;

    default:
      return (_props: SVGProps<SVGSVGElement>) => null;
  }
};

export const BasketUpsellDefaultTitle = (key: string, price: number, isSelected: boolean, tax: number) => {
  if (key === DutyUpsell.DDP) {
    return UpsellDefaultTitle(key);
  }

  if (isSelected) {
    return SelectedUpsellDefaultTitle(key);
  }

  return price === 0
    ? UpsellDefaultTitle(key)
    : tax === 0
      ? `${UpsellDefaultTitle(key)} for {{price}}`
      : `${UpsellDefaultTitle(key)} for {{price}} exc {{taxName}}`;
};

export const SelectedUpsellDefaultTitle = (key: string) => {
  switch (key) {
    case Upsell.SMS:
      return `Text Message Notification`;

    case Upsell.GUARANTEE:
      return 'Delivery Guarantee';

    case Upsell.SIGNATURE:
      return `Proof of Delivery`;

    case Protection.BASE:
      return '{{protectionAmount}} Parcel Protection';

    case Protection.FULL:
      return 'Fully Protected';

    case Label.STORE:
      return 'Print Your Label In Store';

    case DutyUpsell.DDP:
      return 'Duty and Local Taxes';

    default:
      return `{{extra.name}}`;
  }
};

export const UpsellDefaultTitle = (key: string) => {
  switch (key) {
    case Upsell.SMS:
      return `Receive a Delivery Confirmation Text`;

    case Upsell.GUARANTEE:
      return 'Add Delivery Guarantee';

    case Upsell.SIGNATURE:
      return `Include Proof of Delivery`;

    case Protection.BASE:
      return 'Add {{protectionAmount}} Parcel Protection';

    case Protection.FULL:
      return 'Fully Protect Your Parcel';

    case DutyUpsell.DDP:
      return 'Duty and Local Taxes';

    case Label.STORE:
      return 'Print Your Label In Store ';

    default:
      return `{{extra.name}}`;
  }
};

export const UpsellDefaultContent = (key: string, quoteIsDropOff: boolean) => {
  switch (key) {
    case Upsell.SMS:
      return `Get a confirmation text message and instantly know when your parcel is delivered.`;

    case Upsell.GUARANTEE:
      return quoteIsDropOff
        ? 'You will be entitled to a full refund of your carriage if your parcel is not delivered within <1>{{maxDays}} working day(s)</1> after drop off **\n' +
            'e.g. drop off your parcel by <1>{{cutOffTime}} {{cutOffDate}}</1> for guaranteed delivery by <1>{{deliveryGuaranteeDate}}</1>.' +
            '<0>** Not valid if the delivery was attempted or impaired. An additional day is added for drop-offs after {{cutOffTime}}.</0>'
        : 'You will be entitled to a full refund of your carriage if your parcel is not delivered by <1>{{deliveryGuaranteeDate}}</1> **.\n' +
            '<0>** Not valid if the collection or delivery was attempted or impaired.</0>';

    case Upsell.SIGNATURE:
      return `This option requires proof of delivery, like a signature or photo, before your parcel is released.`;

    default:
      return `{{extra.name}} for {{price}}`;
  }
};
